import { routerPatchCall } from '../../axios';
 
const updateProfile = (state, params) => {
  const url = `/customers/profile`;
  const getData = routerPatchCall(state, url, params);
  return getData;
};
 
const updateTerritory = (state, params) => {
  const url = '/customers/profile/territory';
  return routerPatchCall(state, url, params);
};
 
export default { updateProfile, updateTerritory };